var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCauliflower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3029",
    "data-name": "Group 3029",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.567,
    height: 53.327,
    viewBox: "0 0 54.567 53.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3362",
    "data-name": "Path 3362",
    d: "M2062.038,277.221h-12.229a1.084,1.084,0,0,1-1.084-1.085c0-9.512-3.537-15.3-5.646-17.9a1.085,1.085,0,0,1,1.686-1.366,25.829,25.829,0,0,1,4.021,7.092,33.548,33.548,0,0,1,2.093,11.088h10.092a31.876,31.876,0,0,1,3.639-13.753,25.9,25.9,0,0,1,3.709-5.462,1.085,1.085,0,0,1,1.569,1.5,24.372,24.372,0,0,0-3.4,5.044,29.921,29.921,0,0,0-3.371,13.758A1.084,1.084,0,0,1,2062.038,277.221Z",
    transform: "translate(-2027.398 -223.894)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3363",
    "data-name": "Path 3363",
    d: "M2054.2,264.493a1.086,1.086,0,0,1-1.039-.774,23.532,23.532,0,0,0-5.1-9.179,1.084,1.084,0,1,1,1.662-1.394,29.064,29.064,0,0,1,3.4,4.805v-3.2a1.085,1.085,0,1,1,2.169,0v8.659a1.085,1.085,0,0,1-1.085,1.085Z",
    transform: "translate(-2028.773 -223.135)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3364",
    "data-name": "Path 3364",
    d: "M2063.477,266.407a2.069,2.069,0,0,1-.385-.037,1.967,1.967,0,0,1-1.616-1.954v-9.968a1.085,1.085,0,1,1,2.169,0v9.038a39.74,39.74,0,0,1,2.273-4.555,35.505,35.505,0,0,1,4.236-5.843,1.084,1.084,0,1,1,1.614,1.449,35.086,35.086,0,0,0-6.46,10.612A1.956,1.956,0,0,1,2063.477,266.407Z",
    transform: "translate(-2032.558 -223.126)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3365",
    "data-name": "Path 3365",
    d: "M2071.144,247.808a1.082,1.082,0,0,1-.989-.64,10.015,10.015,0,0,1,.677-9.45,1.084,1.084,0,0,1,1.831,1.163,7.847,7.847,0,0,0-.529,7.4,1.086,1.086,0,0,1-.989,1.53Z",
    transform: "translate(-2034.72 -218.83)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3366",
    "data-name": "Path 3366",
    d: "M2048.049,211.791a16.329,16.329,0,0,1,13.274,6.807,7.386,7.386,0,0,1,9.377,7.107,7.261,7.261,0,0,1-.136,1.4,10,10,0,1,1-12.95,14.306,16.285,16.285,0,0,1-9.565,3.091,18.5,18.5,0,0,1-6.146-.757,10.754,10.754,0,0,1-3.392,2.67,11.578,11.578,0,0,1-5.183,1.141,11.845,11.845,0,0,1-10.471-17.38,11.958,11.958,0,0,1,3.123-3.75c-.022-.267-.033-.534-.033-.8a9.612,9.612,0,0,1,9.613-9.612,9.669,9.669,0,0,1,1.408.1,16.3,16.3,0,0,1,11.081-4.329Zm12.847,9.188a1.083,1.083,0,0,1-.912-.5,14.181,14.181,0,0,0-21.9-2.426,1.084,1.084,0,0,1-.984.29,7.446,7.446,0,0,0-8.98,7.283,7.7,7.7,0,0,0,.085,1.132,1.084,1.084,0,0,1-.446,1.048,9.673,9.673,0,0,0,5.572,17.58,8.617,8.617,0,0,0,7.358-3.591,1.085,1.085,0,0,1,1.3-.345,14.681,14.681,0,0,0,6.061.881,14.188,14.188,0,0,0,9.2-3.389,1.085,1.085,0,0,1,1.688.37,7.834,7.834,0,1,0,9.954-10.584,1.084,1.084,0,0,1-.634-1.358,5.209,5.209,0,0,0-6.939-6.477A1.088,1.088,0,0,1,2060.9,220.979Z",
    transform: "translate(-2021.485 -211.791)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3367",
    "data-name": "Path 3367",
    d: "M2032.391,239.06a1.082,1.082,0,0,1-.625-.2,9.6,9.6,0,0,1-3.962-6.4,1.085,1.085,0,0,1,2.145-.325,7.471,7.471,0,0,0,3.068,4.957,1.085,1.085,0,0,1-.626,1.971Z",
    transform: "translate(-2023.231 -217.168)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3368",
    "data-name": "Path 3368",
    d: "M2049.06,225.1a1.089,1.089,0,0,1-1-.665,7.431,7.431,0,0,0-5.363-4.414,1.085,1.085,0,1,1,.435-2.125,9.606,9.606,0,0,1,6.931,5.7,1.086,1.086,0,0,1-1,1.5Z",
    transform: "translate(-2027.118 -213.475)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCauliflower);
export default __webpack_public_path__ + "static/media/Cauliflower.c55095683e269d5da74487c50248c33b.svg";
export { ForwardRef as ReactComponent };